import React from 'react';
import './MessageBubble.css';
import { formatTime } from '../utils/helpers';

const MessageBubble = ({ message, speaker, timestamp }) => {
  const isUser = message.isUser || message.speaker === 'user';

  return (
    <div className={`message-bubble ${isUser ? 'user' : ''}`}>
      <div 
        className="message-avatar"
        style={{ 
          backgroundColor: `${speaker.color}20`,
          borderColor: speaker.color 
        }}
      >
        {speaker.avatar}
      </div>
      
      <div className="message-content">
        <div className="message-header">
          <span 
            className="message-name"
            style={{ color: speaker.color }}
          >
            {speaker.name}
            {message.isAIResponse && <span className="ai-badge">🤖 AI</span>}
          </span>
          <span className="message-time">
            {formatTime(timestamp)}
          </span>
        </div>
        
        <div 
          className="message-text"
          style={{
            backgroundColor: isUser 
              ? `${speaker.color}20` 
              : 'rgba(255, 255, 255, 0.1)',
            borderColor: isUser 
              ? `${speaker.color}40` 
              : 'rgba(255, 255, 255, 0.1)'
          }}
        >
          {message.content}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
